import { Deserializable } from "./deserializable.model";

export class Guia implements Deserializable {
  public _id?: string;
  public id_empresa: string;
  public id_criador: string;
  public id_paciente: string;
  public nome: string;
  public titular: string;
  public documentoCpf: string;
  public celular: string;
  public email: string;
  public empresaEndereco: string;
  public empresaFone: string;
  public status: string;
  public dataNascimento: string;
  public criado_em: Date;
  public dataAtendimento: string;
  public dataPreAgendada: string;
  public confirmaAGendamento: boolean;
  public agendamento: Date;
  public pagamento: string;
  public registro: string;
  public convenio: string;
  public carteirinha: string;
  public procedimentos: [];
  public createdAt: Date;
  public updatedAt: Date;
  public qrCode: string;
  public formPagamento: string;
  public valorTotal: string;
  public registrada: boolean;
  public origem: string;
  public colaborador: string;
  public empresarialId: string;
  public empresarialNome: string;
  public empresarialCnpj: string;
  public empresarialLogo: string;
  public tipoAtendimento: string;
  public formaPagamento: string;
  public empresa: string;

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}

export class FiltrosGuias implements Deserializable {
  public formaPagamento?: string;
  public status?: string;
  public origem?: string;
  public empresa?: string;
  public startDate?: string;
  public endDate?: string;
  public empresarialId?: string;

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}
